import {css} from "glamor";
import React, {Component} from "react";
import PropTypes from "prop-types";
import DataList from "../../../../components/TableListView/DataList";
import ProfileAvatar from "../../../../components/ProfileAvatar";
import Utils from "../../../../common/Utils";
import {Button} from "reactstrap";
import _ from "lodash";

const buttonStyle = css({
    borderRadius: 4,
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    '&:hover': {
        borderRadius: 4,
        boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    }
});

export class ItemsListView extends Component {

    static propTypes = {
        emptyMessage: PropTypes.any,
        addText: PropTypes.string,
        addBtnColor: PropTypes.string,
        addBtnIcon: PropTypes.string,
        onAdd: PropTypes.func,
        maxItems: PropTypes.number,
        onRemove: PropTypes.func,
        title: PropTypes.any,
        header: PropTypes.any,
        columns: PropTypes.array,
        tableOptions: PropTypes.object,
        itemsRenderer: PropTypes.func,
        renderMode: PropTypes.string,
        onChange: PropTypes.func
    };

    static defaultProps = {
        addBtnColor: "green",
        addBtnIcon: "fa fa-plus",
        renderMode: "table"
    };

    constructor(props){
        super(props);
        this.appendItem = this.appendItem.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.appendItems = this.appendItems.bind(this);
        this.setItems = this.setItems.bind(this);

        this._defaultItemsRender = this._defaultItemsRender.bind(this);
        this.getCallbackProps = this.getCallbackProps.bind(this);
        this.state = {
            items: []
        };

    }

    _renderTable(items){

        return <DataList columns={this.props.columns}
                         itemsPerPage={5}
                         listRef={r => this._dataTable = r}
                         responsive
                         {...this.props.tableOptions}
                         data={items}/>

    }

    _renderList(items){

        return items.map((x,k) => {

            const { title , media , subtitle: { key , value } } = x;

            return <div key={k} className="clearfix">

                <div style={{ display: "inline" }} className="pull-left">
                    <ProfileAvatar size={32}  media={media} showFullscreen={false} name={Utils.formatAvatarName(title)}/>
                </div>

                <div className="ml-5">
                    <p style={{ fontSize: "small" }} className="mb-0">{title}</p>
                    <p style={{ fontSize: "0.8em"}} className="mb-0">{key}: {value}</p>
                </div>

                <div className="pull-right">
                    <Button size={"sm"} onClick={() => {

                        const items = this.state.items;
                        items.splice(k,1);

                        this.setState({
                            items
                        });


                    }}><i className="fa fa-trash"/> Remove</Button>
                </div>

                {(k < items.length - 1) && <hr/>}

            </div>

        })
    }

    _defaultItemsRender({ items , addItem , removeItem }){

        const { renderMode } = this.props;

        return <React.Fragment>

            {items.length === 0 ? <div>

                <div className="p-2">

                    <div className={"text-center"}>
                        {this.props.emptyMessage}
                    </div>

                </div>

            </div> : <React.Fragment>

                {renderMode === "list" && this._renderList(items)}

                {renderMode === "table" && this._renderTable(items)}

            </React.Fragment>}



        </React.Fragment>


    }

    updateItem(item,values){

        const items = this.state.items;
        let index = items.findIndex(x => x === item);

        if(index >= 0){

            items[index] = values;
            this.setState({
                items
            }, () => {
                this._handleItemsChanged();
            });

        }

    }

    appendItem(item){

        this.setState(state => ({
            items: state.items.concat(item)
        }), () => {
            this._handleItemsChanged();
        });

    }

    appendItems(items){

        if(Array.isArray(items)){

            this.setState(state => ({
                items: state.items.concat(items)
            }), () => {
                this._handleItemsChanged()
            });
        }

    }

    setItems(items){

        if(Array.isArray(items)){
            this.setState({
                items
            }, () => this._handleItemsChanged())
        }

    }

    removeItem(item){

        const items = this.state.items;
        const index = items.findIndex(x => x === item);
        if(index >= 0){

            items.splice(index,1);

            this.setState({
                items
            }, () => {
                this._handleItemsChanged();
            });

        }

    }

    _handleItemsChanged(){

        const { renderMode } = this.props;
        switch (renderMode) {
            case "table":{

                if(this._dataTable)
                    this._dataTable.refresh();

            }break;
            case "list":{

            }break;
        }

        if(_.isFunction(this.props.onChange)){
            this.props.onChange(this.state.items);
        }
    }

    getCallbackProps(){

        return {
            items: this.state.items,
            addItem: this.appendItem ,
            addItems: this.appendItems,
            setItems: this.setItems,
            removeItem : this.removeItem,
            updateItem: this.updateItem
        };

    }

    render(){

        const { items } = this.state;
        const canAddItems = _.isNil(this.props.maxItems) ? true : items.length < this.props.maxItems;
        const renderCallback = this.props.itemsRenderer || this._defaultItemsRender;

        return <div className="p-2">

            <h6>{this.props.title}</h6>

            {_.isFunction(this.props.header) ? this.props.header(this.getCallbackProps()) : this.props.header}

            {renderCallback ? renderCallback(this.getCallbackProps()) : null}

            {canAddItems && <div className="text-center">
                <Button className={`font-xs p-2 ${buttonStyle} pr-4 pl-4`} color={this.props.addBtnColor} size={"sm"} onClick={async () => {

                    if(_.isFunction(this.props.onAdd)){
                        await this.props.onAdd(this.getCallbackProps());
                    }

                }}><i className={this.props.addBtnIcon}/> {this.props.addText}</Button></div>}

        </div>

    }
}



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/VirtualCredit/ItemsListView.js